import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ConfirmDialogTone = 'default' | 'danger';

export type ConfirmDialogOptions = {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    tone?: ConfirmDialogTone;
};

type ConfirmDialogState = Required<ConfirmDialogOptions> & { resolve: (value: boolean) => void };

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
    private readonly stateSubject = new BehaviorSubject<ConfirmDialogState | null>(null);
    readonly state$ = this.stateSubject.asObservable();

    isOpen(): boolean {
        return Boolean(this.stateSubject.value);
    }

    confirm(options: ConfirmDialogOptions): Promise<boolean> {
        const current = this.stateSubject.value;
        if (current) {
            try {
                current.resolve(false);
            } catch {
                // ignore
            }
        }

        const normalized: Required<ConfirmDialogOptions> = {
            title: options.title || 'Confirm',
            message: options.message || '',
            confirmText: options.confirmText || 'Confirm',
            cancelText: options.cancelText || 'Cancel',
            tone: options.tone || 'default'
        };

        return new Promise<boolean>((resolve) => {
            this.stateSubject.next({ ...normalized, resolve });
        });
    }

    resolve(result: boolean): void {
        const current = this.stateSubject.value;
        if (!current) return;
        this.stateSubject.next(null);
        try {
            current.resolve(result);
        } catch {
            // ignore
        }
    }
}

